import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import treeChanges from 'tree-changes';

import { Card, Tabs, Tooltip, Spin } from 'antd';

import ItemManufactureProcessActions from '../../Stores/ItemManufactureProcess/Actions';

import FinishedItemTable from '../ItemManufactureList/FinishedItemTable';
import SemiFinishedItemTable from '../ItemManufactureList/SemiFinishedItemTable';
import RawMaterialItemTable from '../ItemManufactureList/RawMaterialItemTable';
import ItemManufactureExcelTable from '../ItemManufactureExcel01/ItemManufactureExcelTable';
import ItemDocNoManufactureExcelTable from '../ItemManufactureExcel01/ItemDocNoManufactureExcelTable';

const { TabPane } = Tabs;

class ItemManufactureProcessScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, fetchItemProcess } = this.props;
    if (curSiteFlowId > 0) {
      fetchItemProcess();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, fetchItemProcess } = this.props;

    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        fetchItemProcess();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match, process, appPath, processIsLoading } = this.props;

    return (
      <Card>
        <Spin spinning={processIsLoading}>
          <Tabs type="card" activeKey={match.params.proc_type}>
            {process.map(value => (
              <TabPane
                tab={
                  // eslint-disable-next-line react/jsx-wrap-multilines
                  <Tooltip
                    placement="bottom"
                    title={intl.formatMessage({ id: `${value.proc_type.toLowerCase()}_desc` })}
                  >
                    <Link
                      style={value.proc_type !== match.params.proc_type ? { color: 'black' } : {}}
                      to={`${appPath}/itemManufactureProcess/index/${value.proc_type}`}
                    >
                      <FormattedMessage id={`${value.proc_type.toLowerCase()}_label`} />
                    </Link>
                  </Tooltip>
                }
                key={value.proc_type}
              />
            ))}
          </Tabs>
        </Spin>

        {match.params.proc_type === 'FINISHED_ITEMS' && <FinishedItemTable match={match} />}
        {match.params.proc_type === 'SEMI_FINISHED_ITEMS' && (
          <SemiFinishedItemTable match={match} />
        )}
        {match.params.proc_type === 'RAW_MATERIALS' && <RawMaterialItemTable match={match} />}
        {match.params.proc_type === 'ITEM_EXCEL_01' && <ItemManufactureExcelTable match={match} />}
        {match.params.proc_type === 'ITEM_DOC_NO_EXCEL_01' && (
          <ItemDocNoManufactureExcelTable match={match} />
        )}
      </Card>
    );
  }
}

ItemManufactureProcessScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,
  appPath: PropTypes.string,
  process: PropTypes.arrayOf(PropTypes.object),
  processIsLoading: PropTypes.bool,

  curSiteFlowId: PropTypes.number,
  fetchItemProcess: PropTypes.func
};

ItemManufactureProcessScreen.defaultProps = {
  intl: {},
  match: {},
  appPath: '',
  process: [],
  processIsLoading: false,

  curSiteFlowId: 0,
  fetchItemProcess() {}
};

const mapStateToProps = state => ({
  appPath: state.app.appPath,
  process: state.itemManufactureProcess.process,
  processIsLoading: state.itemManufactureProcess.processIsLoading,

  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  fetchItemProcess: () =>
    dispatch(ItemManufactureProcessActions.itemManufactureProcessFetchItemProcess())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(ItemManufactureProcessScreen));
